var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtwPosClrCsRgb220126(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 251.78 100.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7f35b2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.62,28.33,215.71,85H197.27l-9.22-31.63L178.73,85H160.28l-16.2-42.24H134V61.66c0,8.92,3.61,10.4,8.54,10.4a18.5,18.5,0,0,0,3.88-.5l5,13.16a50.56,50.56,0,0,1-12,1.43c-16.9,0-24.11-6.91-24.11-23.11V42.71h-7.69L91.3,85H72.85L63.63,53.32,54.31,85H35.87L14.16,28.33H35.08L46,62.54,56.39,28.33H70.87L81.38,62.54,92.19,28.33h23.14V18.15l18.66-4V28.33h25.5L170.4,62.54l10.41-34.21h14.47L205.8,62.54l10.8-34.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtwPosClrCsRgb220126);
export default __webpack_public_path__ + "static/media/wtw_pos_clr_cs_rgb_220126.d5f4e6269bcb3728d487701dba154b74.svg";
export { ForwardRef as ReactComponent };